import styled from 'styled-components'

interface IBudgetProgressBarToolTipStyledProps {
  large?: boolean
}

export const BudgetProgressBarTooltipStyled = styled.div<IBudgetProgressBarToolTipStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  max-width: ${(props) =>
    props.theme.typography.pxToRem(props.large ? 474 : 351)};
`
